<template>
  <v-tooltip top content-class="custom-top-tooltip">
    <template v-slot:activator="{ on, attrs }">
      
        <v-card  style="background: #e65100; width: 100%;border-radius: 5px; /* width: fit-content; */" v-bind="attrs" v-on="on">
          <v-card-text>
            <div
              style="font-size: 15px !important; font-weight: 500; color: white"
            >
              <v-icon size="22" color="white" style="color: white;" class="pr-1">mdi-home-edit</v-icon>
              {{ name }}
            </div>
          </v-card-text>
        </v-card>
    
    </template>
    <span>Entity Name</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "EntityAlert",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
